export const BREAKPOINT_HORIZONTAL_SIDEPANEL = 1025;
